import { TWidget } from './widget';

export type TCommonWidgetValue = unknown;
export type TCommonDataObj = {
    [key: string]: string | boolean;
};

export type TBottomSheetCommonData = {
    isOpen?: boolean;
} & TCommonData;
export type TCommonData = {
    value?: TCommonWidgetValue;
};

export type TValidation = {
    regex?: string;
    errorMessage?: string;
} & Pick<TWidget<TCommonData>, 'internalId'>;

export type TCommonInputMessages = {
    helperText?: string;
} & Pick<TButtonDataMessages, 'label' | 'errorMessage'>;

export type TInputData = {
    label?: string;
    regex?: string;
    validations?: Array<TValidation>;
    errorMessage?: string;
    mandatory?: boolean;
    mask?: string;
    submitLength?: number;
    tabIndex?: number;
    messages?: TCommonInputMessages;
} & TCommonData &
    Pick<TCommonInputMessages, 'helperText'>;

export type TTextData = {
    text: string;
    links?: Record<string, string>;
} & TCommonData;

export type TCommonMessages = {
    errorMessage?: string;
};

export type TButtonDataMessages = {
    label?: string;
    timerTitle?: string;
    bottomSheetText?: string;
    bottomSheetButtonLabel?: string;
} & TCommonMessages;

export type TButtonData = {
    label?: string;
    iconName?: string;
    flagIcon?: string;
    default?: boolean;
    messages?: TButtonDataMessages;
} & TCommonData;

export type TTimerButtonData = {
    endDate: string;
} & TButtonData;

export type TItem = {
    id: string;
    value: string | TCommonDataObj;
    title?: string;
    icon?: string;
    selected?: boolean;
    countryIso?: string;
    templateId?: string;
    regex?: string;
};

export type TBalanceItem = {
    currencyIso?: string;
    curIsoIcon?: string;
    curIso?: string;
} & TItem;
export type TListData = {
    items: Array<TItem>;
    templates?: Array<TWidget<unknown>>;
} & TCommonData &
    TButtonData;

/**
 * Data property for widget Phone input
 *
 * @property {selectedCountryIso} string - this additional information for how we can correctly selected the item for country in case the country have the same phone prefix
 */
export type TInputPhoneData = {
    selectedCountryIso?: string;
} & TInputData &
    TButtonData &
    TListData;

export type TContacts = {
    address: string[];
    email: string[];
    icon: (typeof Blob)[];
    name: string[];
    tel: string[];
};
